import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import queryString from 'query-string';
import useUserAuth from '../../utils';
import DraftEditor from './DraftEditor';
import TemplateEditor from './TemplateEditor';
import {
  selectedOrganizationSelector,
  isPublisherSelector,
} from '../../redux/selector';
import { getOrCreatePublisherDraft } from '../../redux/services';
import { toast } from '../../redux/action';

const Sendmessage = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { draft, template } = queryString.parse(location.search);
  const selectedOrg = useSelector(selectedOrganizationSelector);
  const isPublisher = useSelector(isPublisherSelector);

  useUserAuth();

  useEffect(() => {
    if (draft || template) return;
    if (!isPublisher) return;
    if (!selectedOrg?.id) return;

    let cancelled = false;
    getOrCreatePublisherDraft(selectedOrg.id)
      .then(publisherDraft => {
        if (cancelled) return;
        if (!publisherDraft?._id) {
          dispatch(toast('error', 'Could not open the publisher draft'));
          return;
        }
        history.replace(`/dashboard/sendmessage?draft=${publisherDraft._id}`);
      })
      .catch(error => {
        if (cancelled) return;
        console.error(error);
        dispatch(toast('error', 'Could not open the publisher draft'));
      });

    return () => {
      cancelled = true;
    };
  }, [draft, template, isPublisher, selectedOrg?.id]);

  if (draft) return <DraftEditor />;
  if (template) return <TemplateEditor />;
  if (isPublisher) return null;

  history.push('/dashboard/drafts');
  return null;
};

export default Sendmessage;
